import { atom } from 'recoil'

export const pageState = atom({
  key: 'tasksListPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    canCreateTrigger: false,
    fetchingResults: false,
    isEmptyState: false
  }
})
